import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { annulmentApplicationFailed, annulmentApplicationSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { NO_CONTENT } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* annulmentApplication(action) {
  try {
    const { id, values } = action.payload;
    const url = `${BACKEND_URL}/resources/applications/annulment/${id}`;
    const dataResponse = yield makeRequest(url, values, action, 'PUT', true);
    if (dataResponse.status === NO_CONTENT) {
      yield put(annulmentApplicationSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(annulmentApplicationFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(annulmentApplicationFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
